var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 11,
    height: 10,
    rx: 2,
    stroke: "#030723"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.93323L15.2043 3.58347C15.5346 3.34129 16 3.57714 16 3.98668V8.7151C16 9.12465 15.5346 9.36049 15.2043 9.11831L12 6.76855",
    stroke: "#030723"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/Video.d8333a4d69a4d077068be6f95295586d.svg";
export { ForwardRef as ReactComponent };